import { useEffect } from 'react';
import { AlertIcon, CheckIcon, XIcon } from './Icons';

export type ToastData = { id: number; message: string; tone?: 'success' | 'error' | 'info' };

export function Toast({ toast, onDismiss }: { toast: ToastData; onDismiss: () => void }) {
  useEffect(() => {
    const timer = window.setTimeout(onDismiss, 3600);
    return () => window.clearTimeout(timer);
  }, [onDismiss]);

  return (
    <div className={`toast toast--${toast.tone ?? 'info'}`} role="status">
      {toast.tone === 'error' ? <AlertIcon size={18} /> : <CheckIcon size={18} />}
      <span>{toast.message}</span>
      <button type="button" onClick={onDismiss} aria-label="关闭提示"><XIcon size={16} /></button>
    </div>
  );
}
